import * as React from 'react';

function SvgSchedule(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.429 3.143H12.57v-1A.143.143 0 0012.43 2h-1a.143.143 0 00-.143.143v1H8.643v-1A.143.143 0 008.5 2h-1a.143.143 0 00-.143.143v1H4.714v-1A.143.143 0 004.571 2h-1a.143.143 0 00-.142.143v1H.57A.57.57 0 000 3.714V14a.57.57 0 00.571.571H15.43A.57.57 0 0016 14V3.714a.57.57 0 00-.571-.571zm-9 8.286a.143.143 0 01-.143.142H3a.143.143 0 01-.143-.142v-.858c0-.078.064-.142.143-.142h3.286c.078 0 .143.064.143.142v.858zm0-2.429a.143.143 0 01-.143.143H3A.143.143 0 012.857 9v-.857C2.857 8.064 2.921 8 3 8h3.286c.078 0 .143.064.143.143V9zm6.687-1.63l-2.946 4.084a.284.284 0 01-.461 0l-2.04-2.825a.143.143 0 01.117-.227h.98c.091 0 .177.044.23.118l.943 1.305 1.852-2.566a.282.282 0 01.23-.118H13c.116.002.184.134.116.229z" />
    </svg>
  );
}

export default SvgSchedule;
